





import { Component, Vue } from 'vue-property-decorator'

import AuthService from '@/features/auth0/authService'

const auth = new AuthService()

@Component
export default class Callback extends Vue {
  mounted () {
    this.$nextTick(() => {
      auth.handleAuthentication()
    })
  }
};
